import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { ExpandableListRoot, ExpandableToggle } from "./ExpandableList.styles";
export function ExpandableList(_a) {
    var items = _a.items, _b = _a.initialVisibleCount, initialVisibleCount = _b === void 0 ? 4 : _b, _c = _a.mobileOnly, mobileOnly = _c === void 0 ? true : _c, _d = _a.mobileBreakpoint, mobileBreakpoint = _d === void 0 ? 768 : _d, expandLabel = _a.expandLabel, _e = _a.collapseLabel, collapseLabel = _e === void 0 ? "Show less" : _e, className = _a.className, _f = _a.gridOnDesktop, gridOnDesktop = _f === void 0 ? false : _f;
    var _g = useState(false), expanded = _g[0], setExpanded = _g[1];
    var _h = useState(false), isMobile = _h[0], setIsMobile = _h[1];
    useEffect(function () {
        var checkMobile = function () {
            setIsMobile(window.innerWidth <= mobileBreakpoint);
        };
        checkMobile();
        window.addEventListener("resize", checkMobile);
        return function () { return window.removeEventListener("resize", checkMobile); };
    }, [mobileBreakpoint]);
    var shouldCollapse = mobileOnly && isMobile && items.length > initialVisibleCount;
    var hiddenCount = Math.max(items.length - initialVisibleCount, 0);
    var visibleItems = shouldCollapse && !expanded
        ? items.slice(0, initialVisibleCount)
        : items;
    var defaultExpandLabel = "Show ".concat(hiddenCount, " more");
    var showGrid = gridOnDesktop && (!shouldCollapse || !isMobile);
    return (_jsxs(ExpandableListRoot, { className: className, "$grid": showGrid, children: [visibleItems, shouldCollapse && (_jsx(ExpandableToggle, { type: "button", onClick: function () { return setExpanded(function (prev) { return !prev; }); }, "aria-expanded": expanded, style: showGrid ? { gridColumn: "1 / -1" } : undefined, children: expanded ? collapseLabel : expandLabel !== null && expandLabel !== void 0 ? expandLabel : defaultExpandLabel }))] }));
}
